import React, { useMemo, useCallback } from 'react'
import DidYouKnowService from './Service'
import UserResponsesManagerService from '../user-responses-manager/Service'
import { IDidYouKnowProviderProps, IDidYouKnowResponsesValidations } from './Interface'
import { IResponsesValue, IValidationUserResponses } from 'types'
import { useServiceState, useNotification } from 'helpers'

const Provider: React.FC<IDidYouKnowProviderProps> = ({ children, responses, disabled, embeddedPage }) => {
  const userResponsesManagerState = useServiceState(UserResponsesManagerService, false)
  const { emitError } = useNotification()

  const { currentResponses, validations } = useMemo(() => {
    const evaluatedResponses =
      responses || userResponsesManagerState.userResponses?.responses || ({} as IResponsesValue)
    const evaluatedValidations: IValidationUserResponses = responses
      ? null
      : userResponsesManagerState.userResponses?.validation

    return {
      currentResponses: DidYouKnowService.selectDidYouKnowResponses(evaluatedResponses),
      validations: evaluatedValidations
        ? DidYouKnowService.selectValidationKeys(evaluatedValidations)
        : ({} as IDidYouKnowResponsesValidations)
    }
  }, [responses, userResponsesManagerState.userResponses])

  const onQuestionsAnswerChanged = useCallback(
    async (questionKey: string, response: string) => {
      if (responses) {
        return
      }

      const error = await DidYouKnowService.updateQuestionAnswer(questionKey, response)

      if (error) {
        emitError(error)
      }
    },
    [responses, emitError]
  )

  return (
    <React.Fragment>
      {children({
        responses: currentResponses,
        onQuestionsAnswerChanged,
        validations,
        disabled,
        embeddedPage
      })}
    </React.Fragment>
  )
}

export default Provider
